// src/components/Performance/AddNoteModal.tsx

import React from "react";
import { Modal } from "antd";
import AddNoteForm from "./AddNoteForm";

interface AddNoteModalProps {
  open: boolean;
  onCancel: () => void;
  employeeId: number;
  isEdit?: boolean;
  noteData?: any;
  refreshData?: () => void;
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({
  open,
  onCancel,
  employeeId,
  isEdit = false,
  noteData,
  refreshData,
}) => {
  return (
    <Modal
      title={isEdit ? "Edit Performance Note" : "Add Performance Note"}
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      width={800}
    >
      <AddNoteForm
        employeeId={employeeId}
        onCancel={onCancel}
        isEdit={isEdit}
        noteData={noteData}
        refreshData={refreshData}
      />
    </Modal>
  );
};

export default AddNoteModal;